import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLightningFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M8.41 1.75h4.388c1.166 0 2.003 1.213 1.45 2.305L12.79 6.94l1.376.032c1.31.03 2.1 1.552 1.21 2.61l-6.994 8.322a.97.97 0 0 1-1.166.248.954.954 0 0 1-.514-1.099l1.282-5.063-1.785.363c-1.18.24-2.276-.86-1.864-2.069l2.54-7.447A1.62 1.62 0 0 1 8.41 1.75" />
  </svg>
);
export default SvgLightningFull;
